<template>
  <div>
    <el-table
      v-if="data.length"
      :data="data"
      stripe
      :row-class-name="tableRowClassName"
      @cell-click="cellClick"
      @sort-change="filterChanged"
      max-height="650"
      :empty-text="$t('general_noData')"
      style="width: 100%"
      size="small">
      <el-table-column
        prop="transactionDate"
        sortable
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_date')">
      </el-table-column>
      <el-table-column
        sortable
        prop="id"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_refNo')">
        <template slot-scope="scope">
          <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.transactionNo}}</strong>
        </template>
      </el-table-column>
      <el-table-column
        prop="transactionType"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_type')">
      </el-table-column>
      <el-table-column
        prop="transactionDescription"
        align="center"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_description')">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.transactionDescription"
            placement="top"
            title="Description"
            width="400"
            trigger="click"
            :content="scope.row.transactionDescription">
            <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        sortable
        align="center"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_status')">
      </el-table-column>
      <!-- <el-table-column
        header-align="right"
        sortable
        prop="amount"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_amount')">
        <template slot-scope="scope">
          <div style="text-align: right;">{{formatPrice(scope.row.amount)}}</div>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        header-align="right"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_taxAmount')">
        <template slot-scope="scope">
          <div style="text-align: right;">{{formatPrice(scope.row.taxamount)}}</div>
        </template>
      </el-table-column> -->
      <infinite-loading
          v-if="pagesCount > 1"
          slot="append"
          @infinite="infiniteHandler">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </el-table>
    <!--Journal Entry modal edit-->
    <editJournalEntryModal @updateList="getList" :showInfo="false" ref="editJournalEntryModal"/>

  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import { Money, VMoney } from 'v-money'
import axios from 'axios'
import moment from 'moment'
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'
export default {
  name: "deleted",
  components: {
    Money,
    editJournalEntryModal,
    InfiniteLoading,
  },
  directives: {money: VMoney},
  props: {
    transactionId: {
      default: null
    }
  },
  data() {
    return {
      moment: moment,
      data: [],

      order: null,
      orderBy: null,
      page: 1,
      pagesCount: 1,
      count: 20,
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    openModal() {
      this.item()
    },
    tableRowClassName({row, rowIndex}) {
      return 'cursor-pointer';
    },
    item(filterBy = null, filterValue = null, isPagination) {
      return new Promise((resolve, reject) => {
        let copiedArray = []
        if (isPagination) {
          copiedArray = JSON.parse(JSON.stringify(this.data))
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/account/company-ledger/list?transactionCode=DELETED&transactionType=null&companyId=${this.$route.query.companyId}&filterBy=${filterBy}&filterValue=${filterValue}&orderBy=${this.orderBy}&order=${this.order}&page=${this.page}&count=${this.count}`)
            .then(response => {
              this.data = [...copiedArray, ...response.data.list]
              this.pagesCount = response.data.pageCount
              this.data.forEach((item) => {
                item.transactionDate = item.transactionDate ? moment(item.transactionDate).format("D MMM YYYY") : ''
                item.amount = (+item.debit + +item.credit) / 2
              })
              if (this.transactionId) {
                const row = this.data.find(val => val.id == this.transactionId)
                if (row) this.cellClickID(row)
                this.$emit('resetTransition')
              }
              loader.hide()
              resolve(this.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
      })
    },
    handleCurrentChange(val) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/account/general-ledger?accountId=null&companyId=${this.$route.query.companyId}&page=${val}`)
          .then(response => {
            window.scrollTo(0,0)
            // eslint-disable-next-line no-console
            console.log('RERERERE', response.data.item)
            this.data = response.data.item.list
            for (let i = 0; i < this.data.length; i++) {
              this.data[i].transactionDate = this.data[i].transactionDate ? moment(this.data[i].transactionDate).format("D MMM YYYY") : '';
            }
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    getList() {
      this.item()
    },
    cellClick(row, column, cell, event){
      // if (column.label != "Operations") {
      //   this.$refs['editJournalEntryModal'].openModalFromJournalEntry(row)
      // }
    },
    filterChanged(filters) {
      console.log('filters', filters)
      if (filters.order === 'ascending') {
        this.order = 'ASC'
      } else if (filters.order === 'descending') {
        this.order = 'DESC'
      }

      if (filters.prop === 'transactionDate') {
        this.orderBy = 'date'
      } else if (filters.prop === 'id') {
        this.orderBy = 'id'
      } else if (filters.prop === 'amount') {
        this.orderBy = 'amount'
      } else {
        this.orderBy = null
      }
      this.item()
    },
    cellClickID(row){
      if (row.transactionCode === 'GENERAL') {
        this.$refs['editJournalEntryModal'].openModalFromJournalEntry(row)
      } else if (row.transactionCode === 'CASHRECEIPT') {
        this.$router.push(`/cash-receipts/${row.cashReceiptHeader.id}?companyId=${this.$route.query.companyId}`)
      } else if (row.transactionCode === 'CASHDISPERSEMENT') {
        this.$router.push(`/cash-disbursements/${row.cashDisbursement.id}?companyId=${this.$route.query.companyId}`)
      }
      // this.$refs['editJournalEntryModal'].openModalFromJournalEntry(row)
      // this.$router.push(`/cash-receipts/${row.cashReceiptHeader.id}?companyId=${this.$route.query.companyId}`)
    },
    async infiniteHandler($state){
      try {
        if (this.page < this.pagesCount) {
          this.page += 1
          await this.item(null, null, true)
          $state.loaded()
        } else {
          $state.complete()
        }
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sweet-modal-overlay{
  z-index:1000;
}
/deep/.el-table__body-wrapper {
  overflow-y: auto;
}
</style>
